import { AxiosResponse } from 'axios'
import { SetStateAction } from 'react'
import { APIDecoratorWithBaseURI } from '../../Service/api'

export interface RefreshResponseData {
  success?: boolean
  error?: boolean
  message?: string
  errorCode?: string
  data?: {
    accessToken: string
  }
}

export const refreshToken = async (): Promise<
  SetStateAction<string | void>
> => {
  const response = await APIDecoratorWithBaseURI(
    process.env.REACT_APP_API_AUTH
    // 'http://localhost:3200/'
  ).get<String, AxiosResponse<RefreshResponseData>>(
    `auth/dashboard/producer/refresh`,
    {
      responseType: 'json',
      headers: { 'content-type': 'application/json' },
      withCredentials: true,
    }
  )

  if (response.data.data !== undefined) {
    return response.data.data.accessToken
  }
}
